import { searchHubActualites as hubActualitesMapper } from '../helpers/filters/hub-actualites';
import { search } from './search';

export const FILTER_HOME_KEY = 'home-filter';
export const searchHome = search(hubActualitesMapper);
